import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from '../components/ui/Button';
const SLIDES = [{
  id: 1,
  title: 'Discover Comedy',
  description: 'Swipe through an endless feed of stand-up, skits, and pranks tailored just for you.',
  emoji: '🎭',
  color: 'bg-primary'
}, {
  id: 2,
  title: 'Share the Laughs',
  description: 'Upload your own funny moments and build your audience.',
  emoji: '📱',
  color: 'bg-neonOrange'
}, {
  id: 3,
  title: 'Follow Favorites',
  description: 'Never miss a joke from your favorite creators and comedians.',
  emoji: '⭐',
  color: 'bg-purple-500'
}, {
  id: 4,
  title: 'Go Viral',
  description: 'Get on the trending page and become the next big comedy star.',
  emoji: '🚀',
  color: 'bg-emerald-500'
}];
export function Onboarding() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();
  const handleNext = () => {
    if (currentIndex === SLIDES.length - 1) {
      navigate('/auth/register');
    } else {
      setCurrentIndex(prev => prev + 1);
    }
  };
  const handleSkip = () => {
    navigate('/auth/register');
  };
  return <div className="w-full h-full bg-black flex flex-col relative" data-id="element-449">
      {/* Top Bar */}
      <div className="absolute top-0 left-0 right-0 p-6 flex justify-end z-50" data-id="element-450">
        <button onClick={handleSkip} className="text-softGray font-medium text-sm hover:text-white transition-colors" data-id="element-451">
          Skip
        </button>
      </div>

      {/* Carousel Area */}
      <div className="flex-1 relative overflow-hidden" data-id="element-452">
        <AnimatePresence mode="wait" data-id="element-453">
          <motion.div key={currentIndex} initial={{
          opacity: 0,
          x: 100
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -100
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} className="absolute inset-0 flex flex-col items-center justify-center px-8" data-id="element-454">
            {/* Illustration */}
            <div className="relative w-64 h-64 mb-12 flex items-center justify-center" data-id="element-455">
              <motion.div initial={{
              scale: 0
            }} animate={{
              scale: 1
            }} transition={{
              delay: 0.2,
              type: 'spring'
            }} className={`absolute inset-0 ${SLIDES[currentIndex].color} rounded-full opacity-20 blur-2xl`} data-id="element-456" />
              <motion.div initial={{
              scale: 0,
              rotate: -20
            }} animate={{
              scale: 1,
              rotate: 0
            }} transition={{
              delay: 0.1,
              type: 'spring',
              bounce: 0.5
            }} className={`w-40 h-40 ${SLIDES[currentIndex].color} rounded-[40px] rotate-12 flex items-center justify-center shadow-2xl`} data-id="element-457">
                <span className="text-7xl -rotate-12 drop-shadow-lg" data-id="element-458">
                  {SLIDES[currentIndex].emoji}
                </span>
              </motion.div>
            </div>

            {/* Text */}
            <div className="text-center" data-id="element-459">
              <h2 className="text-3xl font-poppins font-bold text-white mb-4" data-id="element-460">
                {SLIDES[currentIndex].title}
              </h2>
              <p className="text-softGray text-base leading-relaxed" data-id="element-461">
                {SLIDES[currentIndex].description}
              </p>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Bottom Controls */}
      <div className="p-8 flex flex-col items-center gap-8 bg-gradient-to-t from-black via-black to-transparent z-10" data-id="element-462">
        {/* Progress Dots */}
        <div className="flex gap-2" data-id="element-463">
          {SLIDES.map((_, index) => <div key={index} className={`h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-primary' : 'w-2 bg-surface2'}`} data-id="element-464" />)}
        </div>

        <Button fullWidth onClick={handleNext} data-id="element-465">
          {currentIndex === SLIDES.length - 1 ? 'Get Started' : 'Next'}
        </Button>
      </div>
    </div>;
}